import HeaderLayout from 'layout/HeaderLayout';
import React, { useEffect, useState } from 'react';
import axiosInstance from 'custom-axios';
import { useParams } from 'react-router';
import { Box, Button, Container, Typography } from '@mui/material';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { toast, ToastContainer } from 'react-toastify';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';
// import { formatDateMonthYear } from 'styles/commonFunction';

const ThankYouPage = () => {

    document.title = 'Raintree wealth Management: Thank You';

    const { id } = useParams();
    let userId = id ? id : 0;

    const loginId = localStorage.getItem('login_id');
    const loginType = localStorage.getItem('login_type');

    let isAdminLogin = (loginType === 'portfolio_manager_admin' || loginType === 'admin') && userId ? true : false
    // let isClientLogin = (loginType === 'client' && userId) ? true : false
    const [managerPermissionData, setManagerPermissionData] = useState({})
    const [userData, setUserData] = useState([])

    const fetchManagerPermission = async () => {
        try {
            const response = await axiosInstance.get(`api/manager-permissions/${loginId}`);

            if (response.status == 200) {
                setManagerPermissionData(response.permissions)
            }

        } catch (error) {
            // console.error(error.message);
        }
    };

    const fetchUserDashboardStatus = async () => {
        try {
            const response = await axiosInstance.get(`api/user-dashboard-status/${userId}`);

            if (response.status === 200) {
                setUserData(response.data)
            }

        } catch (error) {
            // console.error(error.message);
        }
    };

    const accessToDashboard = async () => {
        /* let answer = window.confirm('Are You sure want to complete this?')
        if (answer) { */
        const result = await showConfirmSweetAlert({
            title: 'Complete Action?',
            text: 'Are you sure you want to complete this?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, complete it!',
            cancelButtonText: 'No, cancel!',
        });

        if (result.isConfirmed) {
            let endPoint = `api/access-to-dashboard`;

            const submitData = { access_to_dashboard: 1, user_id: userId }

            try {
                const response = await axiosInstance.post(endPoint, submitData);

                if (response.success) {
                    toast.success(response.message)
                } else {
                    toast.error(response.message)
                }

            } catch (error) {
                // console.error(error)
            }
        }
    }

    const AdminStatus = () => {
        return (
            <div className="text-left">
                <div className="assetsbox_text blue_clr text-left color-124734">
                    Next Steps:
                </div>
                {userData['access_to_dashboard'] === 0 &&
                    <>

                        <div className="assetsbox_text text-left" >
                            - Client competed the all process and singed the agreement, Please click on the button below to give an access to the dashboard.
                            <br /><br />
                            <br />
                        </div>
                        <div className="d-flex justify-content-center">
                            {/* inverse the condition for disable true, access_to_dashboard === 1 means already access to dashboard */}
                            <Button variant="outlined" color="primary" onClick={accessToDashboard} sx={{ marginTop: '20px' }} disabled={managerPermissionData['ACCOUNT OPENING'] === 0}>
                                Access to dashboard
                            </Button>
                        </div>
                    </>
                }

                {userData['access_to_dashboard'] === 1 &&
                    <div className="assetsbox_text text-left" >
                        - This clients registration has completed and given an access to the dashboard.
                        <br /><br />
                        <br />
                    </div>
                }
            </div>
            // </div >
        )
    }
    const fetchAllApi = () => {

        isAdminLogin && fetchManagerPermission()
        fetchUserDashboardStatus()

    }


    useEffect(() => {
        fetchAllApi()
    }, [])

    return (
        <>

            <div className="container p-0 mt-2">
                <Box sx={{ width: '100%', backgroundColor: '#ffffff', padding: '35px' }}>
                    {isAdminLogin && <AdminStatus />}  {/* only admin/pm login can see this message */}
                </Box>
            </div>
            <ToastContainer />
        </>
    );
};

export default ThankYouPage;
